import AccountsTable from "../components/atoms/AccountsTable";

const Accounts = () => {
  return (
    <>
      <AccountsTable />
    </>
  );
};

export default Accounts;
